import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallQueryDocumentIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M7.5 20.25H2.25a1.5 1.5 0 0 1 -1.5 -1.5V2.25a1.5 1.5 0 0 1 1.5 -1.5h10.629a1.5 1.5 0 0 1 1.06 0.439l2.872 2.872a1.5 1.5 0 0 1 0.439 1.06V7.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M10.514 15.75a5.25 5.25 0 1 0 10.5 0 5.25 5.25 0 1 0 -10.5 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m23.25 23.25 -3.774 -3.788"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
